export const CLAIM_STATUSES = {
    PENDING: "PENDING",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED"
}
